import { DropdownButton } from "react-bootstrap";
import styled, { css } from "styled-components";

export const GlobalHeaderWrapper = styled.div`
  .welcome-message {
    color: #2b2928;
    span {
      font-size: 20px;
      font-weight: 400;
      line-height: 36px;
    }
    h3 {
      font-size: 24px;
      font-weight: 600;
      line-height: 36px;
    }
  }
  .handset-welcome-message {
    padding: 12px 16px;
    span {
      font-size: 16px;
    }
  }
`;

export const HeaderWrapper = styled.div`
  padding: 24px 48px 56px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ smallHeader }) =>
    smallHeader &&
    css`
      padding: 12px 24px 12px 40px;
      box-shadow: 0px 4px 12px 0px #0000000a;
      background-color: #fff;
    `}

  .logo-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    .hamburger-menu {
      width: 24px;
      height: 24px;
      display: none;
    }
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    h3 {
      font-size: 14px;
      font-weight: 500;
      color: #242424;
      margin-left: 4px;
    }
    .neap-logo{
      margin-left: auto;
      max-height: 20px;
    }
  }

  @media screen and (max-width: 1240px) {
    padding: 12px 16px;
    .logo-wrapper {
      height: 28px;
      .hamburger-menu {
        display: flex;
      }
      img {
        height: 100%;
      }
    }
  }
`;

export const StyledDropdown = styled(DropdownButton)`
  button {
    padding: 0;
    :focus {
      outline: 0 !important;
      box-shadow: none !important;
    }
    :after {
      content: "";
      display: none;
    }
  }
  .dropdown-menu {
    padding: 6px 8px;
    border: transparent;
    top: 16px !important;
    left: 4px !important;
    &.show {
      ::before {
        border-color: rgba(255, 5, 5, 0) rgba(255, 5, 5, 0) rgb(255, 255, 255);
        border-width: 13px;
        margin-left: -6px;
      }
    }
    ::before {
      bottom: 100%;
      right: 10%;
      border: solid transparent;
      content: " ";
      height: 0px;
      width: 0px;
      position: absolute;
      pointer-events: none;
    }
  }
  .dropdown-item {
    padding: 0.5rem;
    &:active {
      background-color: #eef4f9;
    }
  }
  @media screen and (max-width: 1240px) {
    .dropdown-menu {
      display: none;
    }
  }
`;
